<nb-card>
  <nb-card-header>
    Add a new bartender
  </nb-card-header>
  <nb-card-body>
    <div class="form-group">
      <input type="text" nbInput fullWidth (keyup)="search()" [(ngModel)]="searchValue" [nbAutocomplete]="auto">
      <nb-autocomplete #auto>

        <nb-option *ngFor="let user of users" (click)="clickItem(user)">
          {{ user.firstName + " " + user.lastName }} - {{ user.email }} - {{ user.objectID }}
        </nb-option>

      </nb-autocomplete>
    </div>
    <button (click)="addUser()" nbButton status="success" [disabled]="!(this.userKey && this.userKey.length > 0)">Add</button>
  </nb-card-body>
</nb-card>
<nb-card>
  <nb-card-header>
    Bartenders
  </nb-card-header>
  <nb-card-body>
    <angular2-smart-table [settings]="settings" [source]="source" (deleteConfirm)="onDeleteConfirm($event)" (editConfirm)="onEditConfirm($event)">
    </angular2-smart-table>
  </nb-card-body>
</nb-card>
